/*import logo from './logo.svg';  */
import './App.css';
/* import Saludar from './Components/Saludo.js'
import Cards from './Components/P1Textos.js'  */
import './Components/css/Estilos.css'
import './Components/css/neon.css'
import Quotes from './Components/js/Quotes.js'

/* function >Tres() {
  return (
    <div className='containerFilas'>
    
    <Cards color='green' titulo='hobbies' primer='s' segundo='s' tercero='s'/>
    <Cards color='celeste' titulo='en mi tiempo libre me gusta' primer='s' segundo='s' tercero='s'/>
    <Cards color='yellow' titulo='comidas favoritas' primer='s' segundo='s' tercero='s'/>
    </div>
  );
} */

const App=()=>{

  return (
    <>
      <Quotes/>
      {/* <div className="containerFilas">
        desarrollado por M. Arturo Matheus Tapia
      </div>  */}
    </>
  );
}

export default App;
